import { ICellRendererParams, IComponent } from '@ag-grid-community/core'
import {
  ComponentFactoryResolver,
  EventEmitter,
  ViewContainerRef,
} from '@angular/core'
import { generateMdiIcon } from '@helios/ag-grid-config'
import { PriorityType } from '@helios/generic-components'
import { AccountListAggregateDropdownComponent } from '../account-list-aggregate-dropdown/account-list-aggregate-dropdown.component'

export const enum IconClasses {
  high = 'mdi-alert-circle', //text-danger
  medium = 'mdi-alert', //text-warning
  waiting = 'mdi-clock-outline',
  completed = 'mdi-checkbox-marked-circle', //text-success
  unknown = 'mdi-help-box',
}

const priorityTypes: Map<PriorityType, string> = new Map([
  ['high', generateMdiIcon('mdi-chevron-triple-up', ['text-danger'])],
  ['medium', generateMdiIcon('mdi-chevron-double-up', ['text-warning'])],
  ['low', generateMdiIcon('mdi-chevron-double-down', ['text-success'])],
  ['unknown', generateMdiIcon('mdi-minus')],
])

export const priorityCellRenderer = (params: ICellRendererParams) =>
  priorityTypes.get(params.value) ?? generateMdiIcon('mdi-minus')

/**
 * Since Ag Grid doesn't support async menu items, this component
 * is used to generate dynamically an angular component, which
 * passes the aggregates
 */
export class AccountListAggregatesDropdown implements IComponent<string> {
  constructor(
    private readonly accountId: number,
    private readonly resolver: ComponentFactoryResolver,
    private readonly container: ViewContainerRef,
    private readonly aggregateChanged: EventEmitter<number>,
    private readonly parentPortfolioId?: number,
  ) {}

  getGui(): HTMLElement {
    // Generate the component
    const compiledComponent = this.resolver.resolveComponentFactory(
      AccountListAggregateDropdownComponent,
    )
    const component =
      this.container.createComponent<AccountListAggregateDropdownComponent>(
        compiledComponent,
      )
    const instance = component.instance

    // Since the component reference is passed, I can now change the data
    instance.parentPortfolioId = this.parentPortfolioId
    instance.accountId = this.accountId

    // Pass the selected Id Upwards
    instance.aggregateIdChanged.subscribe(id => this.aggregateChanged.next(id))

    // Return the native element from the component
    return component.location.nativeElement
  }
}
